import vine from '@vinejs/vine'
import { orgRichTextVine } from '~/validators/orgRichText'
import { createAndUpdateValidator, optionalLongLabelField, orgLibField } from '~/validators/orgFields'

const agenceValidators = createAndUpdateValidator(function agenceSchema() {
  return vine.object({
    dirLib: orgLibField(),
    domLib: orgLibField(),
    ageLib: orgLibField(),
    ageLibLong: optionalLongLabelField(),
    ageDesc: orgRichTextVine().nullable(),
  })
})

export const createAgenceValidator = agenceValidators.create
export const updateAgenceValidator = agenceValidators.update

export const patchAgenceValidator = vine.create(
  vine.object({
    dirLib: orgLibField().nullable().optional(),
    domLib: orgLibField().nullable().optional(),
    ageLib: orgLibField().nullable().optional(),
    ageLibLong: optionalLongLabelField(),
    ageDesc: orgRichTextVine().nullable().optional(),
  })
)
